// frontend/src/components/LandingPage/CategoryCard.js
import React from "react";
import "./CategoryCard.css";

const CategoryCard = ({ category, onClick }) => {
  return (
    <div onClick={onClick} className="category-card">
      <div className="category-card-image-container">
        <img
          src={category.image}
          alt={category.name}
          className="category-card-image"
        />
      </div>
      <div className="category-card-overlay">
        <h2 className="category-card-title">{category.name}</h2>
      </div>
    </div>
  );
};

export default CategoryCard;
